export default __webpack_public_path__ + "static/media/Shri Thanedar .b5bc29a8.jpg";